import styled from 'styled-components';

export default (Component) => styled(Component)`
  .modal-body {
    text-align: center;
    span {
      font-size: 18px;
      font-weight: bold;
    }
    .modal-body__button-block {
      margin-top: 35px;
      a {
        padding: 13px;
        margin: 0 10px;
      }
      a:nth-child(1) {
        width: 97px;
      }
      a:nth-child(2) {
        width: 82px;
      }
    }
  }
`;
